import React, { Component } from "react";

import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import { logout } from "../../../actions/baseActions";
import { setLayout } from "../../../actions/layoutActions";
import {
  setObj,
  showHelpdesk,
  hideHelpdesk
} from "../../../actions/noteActions";
import Chat from "../../../components/Etutor/Chat";
import HelpdeskModal from "../../../components/HelpdeskModal";
import Interface from "../../../components/Interface";
import ProtectedRoute from "../../../components/ProtectedRoute";
import URL from "../../../config/api";
import axios from "../../../config/axios";
import NotesSidebar from "../../../layout/NotesSidebar";

class ContentView extends Component {
  constructor(props) {
    super(props);

    this.state = {
      title: ""
    };
  }

  componentDidMount() {
    const { id } = this.props.match.params;
    axios
      .get(`${URL.api}content/los/listLosLos/${id}`, {
        headers: { authorization: `Bearer ${this.props.user.token}` }
      })
      .then(resp => {
        const data = resp.data.data;
        let realTitle = "Conteúdo";

        if (Array.isArray(data) && data.length > 0) {
          realTitle = data[0].name;
        } else if (data && data.name) {
          realTitle = data.name;
        }

        this.setState({ title: realTitle });
        document.title = realTitle;
      })
      .catch(err => {
        this.setState({ title: "Educandus" });
        document.title = "Educandus";
      });
  }

  render() {
    return (
      <>
        {this.props.note?.showHelpdesk && (
          <HelpdeskModal
            show={this.props.note.showHelpdesk}
            base64image={this.props.note.base64image}
            onClose={() => this.props.hideHelpdesk()}
          />
        )}
        <NotesSidebar />
        <div
          className="overflow-hidden d-flex flex-column"
          style={{ width: "100vw", height: "100vh" }}
        >
          <Interface
            fullscreen
            title={this.state.title}
            aula={this.props.match.params.id}
            currentRoute={this.props.currentRoute}
          />
          {/* <Chat token={this.props.user.token + this.props.match.params.id} /> */}
        </div>
        <ProtectedRoute routeId={this.props.currentRoute} />
      </>
    );
  }
}

ContentView.propTypes = {
  hideLayout: PropTypes.bool,
  guestLogin: PropTypes.bool
};

ContentView.defaultProps = {
  hideLayout: true,
  guestLogin: false
};

const mapStateToProps = state => ({
  user: state.user,
  general: state.general,
  profile: state.profile,
  layout: state.layout,
  note: state.note
});

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    { setLayout, logout, setObj, showHelpdesk, hideHelpdesk },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(ContentView);
